// extracted by mini-css-extract-plugin
export default {"root":"fISzffg6cT","toRow":"DOlRgW_u95"};